<script setup>
import { Link } from '@inertiajs/vue3';
const props = defineProps(['classes'])
</script>

<template>
  <Link href="/">
    <img width="150" height="65" :class="classes" src="@img/logo.webp" alt="ABN Finder" />
  </Link>
</template>
